export default {"src":"https://kroemtech.ch//_next/static/media/report-charts.7a80a02a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};